// roman to int taken from:
// https://www.w3resource.com/javascript-exercises/javascript-math-exercise-22.php

const charToInt = (char: string) => {
  switch (char) {
    case 'I':
      return 1;
    case 'V':
      return 5;
    case 'X':
      return 10;
    case 'L':
      return 50;
    case 'C':
      return 100;
    case 'D':
      return 500;
    case 'M':
      return 1000;
    default:
      return -1;
  }
};

const romanToInt = (romanString: string) => {
  if (!romanString) return undefined;
  let num = charToInt(romanString.charAt(0));
  let pre: number;
  let curr: number;

  for (let i = 1; i < romanString.length; i += 1) {
    curr = charToInt(romanString.charAt(i));
    pre = charToInt(romanString.charAt(i - 1));
    if (curr <= pre) {
      num += curr;
    } else {
      num = num - pre * 2 + curr;
    }
  }

  return num;
};

export default romanToInt;
